import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const InlineBtn = styled.span`
    color: ${COLORS.Link};
    cursor: pointer;
`;
